const NotFoundPage = () => {
  return (
    <div>
      404 page
    </div>
  );
}

export default NotFoundPage;
